import { Link } from 'react-router-dom'
import logo from '@/assets/logo.svg'

export const HeaderBranding = () => {
  return (
    <h1 className="text-2xl font-medium">
      <Link to="/" className="flex gap-0 items-center">
        <img src={logo} alt="Myra Labs" className="w-auto h-10" />
      </Link>
    </h1>
  )
}
